import { BiContextProvidedValue } from '@wix/da-bi/pkg/events';
import { getDeviationResourceType } from '../DeviationViews/_helpers';
import { DeviationResourceType } from '../types/deviation';
import { ResourceType } from '../types/resource';
export function getRecipientSectionName(typeId) {
    let sectionName;
    if (DeviationResourceType[typeId]) {
        sectionName = 'deviation';
    } else if (typeId === ResourceType.COMMENT) {
        sectionName = 'comments';
    } else {
        sectionName = BiContextProvidedValue;
    }
    return sectionName;
}
export function getRecipientForDeviation(deviation) {
    return {
        typeId: getDeviationResourceType(deviation),
        itemId: deviation.deviationId,
        user: deviation.author
    };
}
export function getRecipientForComment(comment) {
    return {
        comment,
        typeId: ResourceType.COMMENT,
        itemId: comment.commentId,
        user: comment.user
    };
}
export const badgeNotificationsFilter = (badgeName)=>(notification)=>{
        var _notification_params_badge, _notification_params;
        return ((_notification_params = notification.params) === null || _notification_params === void 0 ? void 0 : (_notification_params_badge = _notification_params.badge) === null || _notification_params_badge === void 0 ? void 0 : _notification_params_badge.name) === badgeName;
    };

//# sourceMappingURL=utils.js.map